import React from "react"

import Airtable from "airtable"
import MarkdownView from "react-showdown"

import { ChildSelector } from "../helpers/ChildSelector"

import Spinner from "./_base/Spinner"

import { Trans } from "gatsby-plugin-react-i18next"

import moment from "moment"

import * as eventsStyles from "../styles/Events.module.css"

export const Events = props => {
  const [eventsData, setEventsData] = React.useState(null)

  const fetchData = async (
    sortingField = `When`,
    sortingDirection = `asc`,
    comparator = `after`,
  ) => {
    const base = new Airtable({
      apiKey: process.env.GATSBY_AIRTABLE_READ_ONLY_API_TOKEN,
    }).base("apprjcmXKnjtt3t43")

    let data = []
    base("Event List")
      .select({
        view: "Grid view",
        filterByFormula:
          comparator !== `before`
            ? `IS_AFTER({When}, TODAY())`
            : `IS_BEFORE({When}, TODAY())`,
        sort: [{ field: sortingField, direction: sortingDirection }],
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.

          records.forEach(function (record) {
            if (record.fields) data.push(record.fields)
          })

          // To fetch the next page of records, call `fetchNextPage`.
          // If there are more records, `page` will get called again.
          // If there are no more records, `done` will get called.
          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }

          setEventsData(data)
        },
      )
  }

  React.useEffect(() => {
    const fetchInitialData = async () => {
      fetchData(
        `When`,
        props.className.split(` `).includes(`icw-past-events`) ? `desc` : `asc`,
        props.className.split(` `).includes(`icw-past-events`)
          ? `before`
          : `after`,
      )
    }

    fetchInitialData().catch(console.error)
  }, [props.className])

  const title = ChildSelector.select(
    props.content,
    `events-header`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <div className={`row ${eventsStyles.wrapper} ${props.className}`}>
      <div className={`col-12 ${eventsStyles.holder}`}>
        <div className={`row`}>
          <div className={`col-12 ${eventsStyles.sectionHeader}`}>
            <h1>{title}</h1>
          </div>
        </div>

        {!eventsData && (
          <div className={`row ${eventsStyles.loadingWrapper}`}>
            <div className={`col-12 ${eventsStyles.loading}`}>
              <Spinner message={`Loading all our events, stay with us`} />
            </div>
          </div>
        )}

        <div className={`row d-none d-lg-flex ${eventsStyles.eventItemHeader}`}>
          <div
            className={`col-12 d-lg-none ${eventsStyles.eventCondensedInfo}`}
          >
            <Trans>Name</Trans>
          </div>

          <div className={`col-2 d-none d-lg-flex ${eventsStyles.name}`}>
            <Trans>Name</Trans>
          </div>
          <div className={`col-1 d-none d-lg-flex ${eventsStyles.when}`}>
            <Trans>When</Trans>
          </div>
          <div className={`col-2 d- d-lg-flex ${eventsStyles.location}`}>
            <Trans>Location</Trans>
          </div>
          <div className={`col-4 d-none d-lg-flex ${eventsStyles.description}`}>
            <Trans>Description</Trans>
          </div>
          <div className={`col-1 d-none d-lg-flex ${eventsStyles.format}`}>
            <Trans>Format</Trans>
          </div>
          <div className={`col-1 d-none d-lg-flex ${eventsStyles.language}`}>
            <Trans>Language</Trans>
          </div>
          <div
            className={`col-1 d-none d-lg-flex ${eventsStyles.registration}`}
          >
            <Trans>Registration</Trans>
          </div>
        </div>

        {eventsData &&
          eventsData.length > 0 &&
          eventsData.map((cd, idx) => (
            <div
              key={idx}
              className={`row ${eventsStyles.eventItem} ${
                idx % 2 === 0 ? eventsStyles.evenRow : ``
              }`}
            >
              <div
                className={`col-12 d-lg-none ${eventsStyles.eventCondensedInfo}`}
              >
                <div className={`row ${eventsStyles.name}`}>
                  <div className={`col-12`}>
                    <span dangerouslySetInnerHTML={{ __html: cd.Name }}></span>
                  </div>
                </div>
                <div className={`row ${eventsStyles.where}`}>
                  <div className={`col-8`}>
                    {moment(cd.When).format("DD MMMM yyyy")}
                  </div>
                </div>
                <div className={`row ${eventsStyles.location}`}>
                  <div
                    className={`col-12`}
                    dangerouslySetInnerHTML={{
                      __html: `${cd.City || ``} ${cd.Country || ``}`,
                    }}
                  />
                </div>
                {cd.RegistrationLink && (
                  <div className={`row ${eventsStyles.registration}`}>
                    <div className={`col-12`}>
                      <a href={`${cd.RegistrationLink}`} target="_blank">
                        <Trans>Register</Trans>&nbsp;
                      </a>
                    </div>
                  </div>
                )}
              </div>
              <div
                className={`col-2 d-none d-lg-flex ${eventsStyles.name}`}
                dangerouslySetInnerHTML={{ __html: cd.Name }}
              />
              <div className={`col-1 d-none d-lg-flex ${eventsStyles.when}`}>
                {moment(cd.When).format("DD MMMM yyyy")}
              </div>
              <div
                className={`col-2 d-none d-lg-flex ${eventsStyles.location}`}
              >
                {cd.Location}
              </div>
              <div
                className={`col-4 d-none d-lg-flex ${eventsStyles.description}`}
              >
                {cd.Description}
              </div>
              <div className={`col-1 d-none d-lg-flex ${eventsStyles.format}`}>
                {cd.Format}
              </div>
              <div
                className={`col-1 d-none d-lg-flex ${eventsStyles.language}`}
              >
                {cd.Language}
              </div>
              <div
                className={`col-1 d-none d-lg-flex ${eventsStyles.registration}`}
              >
                {cd.RegistrationLink ? (
                  <a href={`${cd.RegistrationLink}`} target="_blank">
                    <Trans>Learn more</Trans>
                  </a>
                ) : (
                  <span className={eventsStyles.comingSoon}>
                    <Trans>Opens Soon</Trans>
                  </span>
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default Events
